import { render, staticRenderFns } from "./ConfigDetail.vue?vue&type=template&id=00efe3de&scoped=true&"
import script from "./ConfigDetail.vue?vue&type=script&lang=ts&"
export * from "./ConfigDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigDetail.vue?vue&type=style&index=0&id=00efe3de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efe3de",
  null
  
)

export default component.exports